<template>
	<div class="qd-card my-2">
		<div class="section-title">شرط ها:</div>
		<condition-group :conditions="modelValue" :variables="variables" :fields="fields" v-model="conditionModel" />
	</div>
</template>

<script>
	export default {
		name: 'conditions',
		props: {
			columns: {
				type: Array,
				default: () => [],
			},
			variables: {
				type: Array,
				default: () => [],
			},
			modelValue: {
				type: Object,
			},
		},
		emits: ['update:modelValue'],
		data() {
			return {
				localData: {
					groupConditions: [],
				},
				conditionModel: null,
			}
		},
		watch: {
			conditionModel: {
				deep: true,
				handler() {
					this.$emit('update:modelValue', this.conditionModel)
				},
			},
		},
		computed: {
			fields() {
				let t = this.columns.map((column) => {
					return {
						title: column.alias && column.alias != '' ? column.alias : column.titlePath,
						path: column.path,
						type: column.type,
						enumItems: column.enumItems,
						aggregate: column.aggregate,
					}
				})
				return t
			},
		},
	}
</script>

<style></style>